import { styled } from '@mui/styles';
import { alpha, Box } from '@mui/material';

const CONTROL_HEIGHT = '56px'; // bumped from 42/43px — shared by currency box, stepper, and amount input

export const StyledCauseAmountInput = styled(Box)(({ theme }) => ({
	'& .AmountSectionWrapper': {
		backgroundColor: '#F7F7F7',
		border: '1px solid #EDEDED',
		borderRadius: '14px',
		padding: '20px',
	},
	'& .currency-box-out': {
		flex: 1,
		width: 'auto',
	},

	'& .StepperModeRow, & .AmountModeRow': {
		gap: '16px',
		alignItems: 'stretch',
	},

	'& .currency-box-inn-area': {
		border: '1px solid #C1C1C1',
		backgroundColor: '#fff',
		height: CONTROL_HEIGHT,
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'space-between',
		borderRadius: '10px',
		padding: '0 14px',
		fontSize: '16px', // cascades to the option label text rendered inside by react-custom-flag-select
		fontWeight: 600,

		// react-custom-flag-select renders the flag via the classNameFlag/classNameDropdownFlag props,
		// which are set to "droop-down-flag" in FlagsDropdown.js — scaling that class up enlarges the flag icon
		'& .droop-down-flag': {
			width: '28px',
			height: '20px',
			transform: 'scale(1.15)',
		},
	},

	'& .QuantityStepperBox': {
		flex: 1,
		display: 'flex',
		alignItems: 'center',
		backgroundColor: '#fff',
		justifyContent: 'space-between',
		border: '1px solid #C1C1C1',
		height: CONTROL_HEIGHT,
		padding: '0 10px',
		borderRadius: '10px',

		[theme.breakpoints.down('sm')]: {
			flex: 'unset',
		},

		'& .MuiIconButton-root': {
			border: `1px solid ${alpha(theme.palette.primary.main, 0.5)}`,
			borderRadius: '10px',
			padding: '8px', // bumped from 5px — bigger tap target
			backgroundColor: theme.palette.primary.main,
			color: '#fff',
			transition: 'background-color .15s ease, border-color .15s ease, color .15s ease',

			'& svg': {
				fontSize: '20px', // bumped from default ~18px
			},

			'&:hover': {
				backgroundColor: theme.palette.primary.dark || theme.palette.primary.main,
			},

			'&.Mui-disabled': {
				backgroundColor: '#F3F3F3',
				borderColor: '#C1C1C1',
				color: '#C1C1C1',
			},
		},

		'& .QuantityValue': {
			fontWeight: 700,
			fontSize: '20px', // bumped from 16px
			minWidth: '32px', // bumped from 24px
			textAlign: 'center',
		},
	},

	'& .FieldLabelsRow': {
		'& .FieldLabel': {
			flex: 1,
			fontSize: '11px',
			fontWeight: 700,
			letterSpacing: '0.5px',
			textTransform: 'uppercase',
			color: theme.palette.text.secondary,
			marginBottom: '6px',
		},
	},

	'& .MuiOutlinedInput-root': {
		height: CONTROL_HEIGHT,
		borderRadius: '10px',
		backgroundColor: '#fff',

		'& .MuiOutlinedInput-notchedOutline': {
			borderRadius: '10px',
			borderWidth: '1px',
		},

		'&.Mui-focused .MuiOutlinedInput-notchedOutline': {
			borderRadius: '10px',
			borderWidth: '2px', // slightly thicker focus ring now that the box is bigger
		},

		'& input': {
			color: '#333333',
			textAlign: 'right',
			paddingLeft: '9px',
			marginRight: '-5px',
			fontWeight: 700,
			fontSize: '20px', // bumped — was inheriting default body size
			lineHeight: '24px',
		},
	},

	'& .FundraisingGoalBox': {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'space-between',
		backgroundColor: alpha(theme.palette.primary.main, 0.08),
		border: `1px solid ${alpha(theme.palette.primary.main, 0.2)}`,
		borderRadius: '12px',
		padding: '16px 20px',
		marginTop: '20px',

		[theme.breakpoints.down('sm')]: {
			flexDirection: 'column',
			alignItems: 'flex-start',
		},

		'& .GoalLabel': {
			fontSize: '11px',
			fontWeight: 700,
			letterSpacing: '0.5px',
			textTransform: 'uppercase',
			color: theme.palette.primary.main,
		},
		'& .GoalSubLabel': {
			fontSize: '13.5px',
			color: theme.palette.text.secondary,
			marginTop: '2px',
		},
		'& .GoalTotal': {
			fontSize: '22px',
			fontWeight: 700,
			color: theme.palette.primary.main,
		},
	},
}));
